import type { LoaderFunction } from "react-router";
import type { Services } from "../services/services";
import { redirect } from "react-router";


const getDefaultUrl = (services: Omit<Services, "navigation">): string | URL => {
	const gaffUrl = services.reference.setting("agentUrl");

	if(services.auth.hasPermission("ADMIN")) {
		return new URL("/app/#/fleet", gaffUrl);
	}

	if(services.auth.hasPermission("CHARTER")) {
		return "/broker/search";
	}

	if(services.auth.hasSomePermissions([ "YACHT", "CENTRAL" ])) {
		return new URL("/app/#/fleet", gaffUrl);
	}

	// Eventually this should become the company management page.
	return new URL("/app/#/profile", gaffUrl);
};

export const defaultLoader = (services: Omit<Services, "navigation">): LoaderFunction => async ({ request }): Promise<Response | null> => {
	const location = new URL(request.url);

	// Handle default routing.
	if(location.pathname === "/") {
		const defaultUrl = getDefaultUrl(services);

		if(window.location.host.startsWith("localhost")) {
			// Don't actually route in local development...
			alert(`Would route to ${defaultUrl}`); // eslint-disable-line no-alert
			return null;
		}

		if(defaultUrl instanceof URL) {
			window.location.href = defaultUrl.href;
			return null;
		}

		return redirect(defaultUrl);
	}
	return null;
};
